
import { createSlice } from '@reduxjs/toolkit';
import { fetcherDelete, fetcherGet, fetcherPost, fetcherPut } from "../utils/fetcher";
import { APIS, isEmpty, meetingPlans, SpecificPlan, role } from '../utils/constants';
import { setLoader } from './commonSlice';
import axios from 'axios';
import { checkNextPage } from '../utils/logger';
const getAccessToken = () => localStorage.getItem("idToken");

const initialState = {
    userInfo: {},
    loggedInUserId: 0,
    studentQuestions: {},
    savedAnswer: {},
    studentProfileIfo:{},
    schoolList: [],
    highSchoolList:{},
    isSurveyCompleted: null,
    language: {},
    prefarances: [],
    skipPrefarancesPage: false,
    formErrorsBasicInfo: {},
    formErrorsAcademicBackground: {},
    savedAnswerForPrefarances: {},
    isEditApprovedBySuperadmin: false,
    plansLookUp: [],
    meetingPlansList: [],
    essayPlans: [],
    combinedPlans: [],
    userSubcription: [],
    userCredit: [],
    getGradeList: [],
    studentList:[],
    adminMentorList:[],
    flagDetails:[],
    materialData:[],
    selectedStudent:null,
    notifications: [],
    errorMsg: {},
    notificationCount: {}
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        setLoggedInUserId: (state, action) => {
            state.loggedInUserId = action.payload;
        },
        setStudentQuestions: (state, action) => {
            state.studentQuestions = action.payload;
        },
        setSavedAnswers: (state, action) => {
            state.savedAnswer = action.payload;
        },
        setSchoolList: (state, action) => {
            state.schoolList = action.payload
        },
        setSurveyCompleted: (state, action) => {
            state.isSurveyCompleted = action.payload
        },
        setLanguage: (state, action) => {
            state.language = action.payload
        },
        setPrefarances: (state, action) => {
            state.prefarances = action.payload
        },
        setSkipPrefarancesPage: (state, action) => {
            state.skipPrefarancesPage = action.payload
        },
        setFormErrorsBasicInfo: (state, action) => {
            state.formErrorsBasicInfo = action.payload
        },
        setFormErrorsAcademicBackground: (state, action) => {
            state.formErrorsAcademicBackground = action.payload
        },
        setPrefarancesSaved: (state, action) => {
            state.savedAnswerForPrefarances = action.payload
        },
        setPlansLookUp: (state, action) => {
            state.plansLookUp = action.payload
        },
        setMeetingPlans: (state, action) => {
            state.meetingPlansList = action.payload
        },
        setEssayPlans: (state, action) => {
            state.essayPlans = action.payload
        },
        setCombinedPlans: (state, action) => {
            state.combinedPlans = action.payload
        },
        setUserSubcription: (state, action) => {
            state.userSubcription = action.payload
        },
        setUserCredit: (state, action) => {
            state.userCredit = action.payload
        },
        setHighSchoolList: (state, action) => {
            state.highSchoolList = action.payload
        },
        setAllGrade: (state, action) => {
            state.getGradeList = action.payload
        },
        setStudentList: (state, action) => {
            state.studentList = action.payload
        },
        setAdminMentorList: (state, action) => {
            state.adminMentorList = action.payload
        },
        setFlagDetails: (state, action) => {
            state.flagDetails = action.payload
        },
        setStudentProfileIfo: (state, action) => {
            state.studentProfileIfo = action.payload
        },
        setMaterialData: (state, action) => {
            state.materialData = action.payload
        },
        setSelectedStudent: (state, action) => {
            state.selectedStudent = action.payload
        }, 
        setNotifications: (state, action) => {
            state.notifications = action.payload
        }, 
        setNotificationCount: (state, action) => {
            state.notificationCount = action.payload
        }
    }
});

export function getUserInfo() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS?.GET_USER_INFO)
            .then((response) => {
                const student = !isEmpty(response?.data) ? response?.data : {}
                dispatch(setUserInfo(student));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getLanguages(page = 1) {
    return (dispatch) => {
        let url = `${APIS.GET_LANGUAGES}${page}&fields=all`;
        fetcherGet(url)
            .then((response) => {
                const languages = !isEmpty(response?.data?.result[0]) ? response?.data : {};
                dispatch(setLanguage(languages));
            })
            .catch((err) => {
                console.error(err);
            });
    };
}

export function getPrefarancesSaved() {
    return (dispatch) => {
        fetcherGet(APIS?.GET_PREFARANCES)
            .then((response) => {
                const allPrefarances = !isEmpty(response?.data[0]) ? response?.data : []
                dispatch(setPrefarancesSaved(allPrefarances));
            })
            .catch((err) => {
                console.error(err);
            });
    };
}
export function getPrefarances() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS?.GET_PREFARANCES_OPTIONS)
            .then((response) => {
                const allPrefarances = !isEmpty(response?.data?.prefences?.[0]) ? response?.data?.prefences : [];
                if(response?.data?.isRankingOptionsAreAvailable === false){
                    dispatch(setSkipPrefarancesPage(true));     
                } 
                dispatch(setPrefarances(allPrefarances));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                dispatch(setLoader(false));
                console.error(err);
            });
    };
}

export function putStudentData(payload, studentId) {
    let url = `${APIS?.PUT_STUDENT_INFO}`
    if (studentId) {
        url = url + `?user_id=${studentId}`
     }
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(url, payload)
            .then(() => {
                dispatch(studentId ? getStudentProfileInfo(studentId) : getQuestionsSavedAnswers());
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getUserQuestions(studentId) {
    let url = `${APIS?.GET_USER_QUESTIONS}`
    if (studentId){
        url = url + `?user_id=${studentId}`
    }
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(url)
            .then((response) => {
                const questions = !isEmpty(response?.data) ? response?.data : {};
                dispatch(setStudentQuestions(questions));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function postQuestionsData(payload, studentId) {
    let url = `${APIS?.POST_STUDENT_QUESTIONS_ANSWER}`
    if(studentId){
       url = url + `?user_id=${studentId}`
    }
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(url, payload)
            .then(() => {
                dispatch(setLoader(false));
                dispatch(studentId ? getStudentProfileInfo(studentId) : getQuestionsSavedAnswers());
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function editProfile(payload, studentId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.PROFILE_EDIT, payload)
            .then(() => {
                dispatch(setLoader(false));
                dispatch(studentId ? getStudentProfileInfo(studentId) : getQuestionsSavedAnswers());
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function postPrefarances(payload) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.POST_PREFARANCES, payload)
            .then(() => {
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getQuestionsSavedAnswers() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.GET_USERS_SAVED_ANSWERS_MAPPING)
            .then((response) => {
                const answers = !isEmpty(response?.data) ? response?.data : {};
                dispatch(setSavedAnswers(answers));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getSchooList(page = 1, searchword = '', isB2B = false) {
    return (dispatch) => {
        // do not add loader here
        // dispatch(setLoader(true));
        let url;
        if (isB2B) {
            url =`${APIS.GET_SCHOOL_LIST}?page=${page}&search=${searchword}&is_basic=${isB2B}`;
        } else {
            url = `${APIS.GET_SCHOOL_LIST}?page=${page}&search=${searchword}`;
        }

        fetcherGet(url)
            .then((res) => {
                dispatch(setSchoolList(!isEmpty(res?.data?.result) ? res?.data?.result : []));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getFlagDetails() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.GET_FLAG_DETAIL)
            .then((res) => {
                dispatch(setFlagDetails(!isEmpty(res?.data) ? res?.data : []));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getHighSchooList(page = 1, prev = [], searchQuery) {
    return (dispatch) => {
        // dispatch(setLoader(true));
        let url = `${APIS.GET_HIGH_SCHOOL_LIST}${page}`;
        if (searchQuery?.length) {
            url = url + `&search=${searchQuery}`
        }
        fetcherGet(url)
            .then((response) => {
                const schools = !isEmpty(response?.data) ? response?.data : {};
                const res = checkNextPage(schools.pagination)
                schools.pagination = res;
                schools.result = [...prev, ...schools.result];
                dispatch(setHighSchoolList(schools));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getStudentList(page = 1, searchQuery, limit= 10, page_flag) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.GET_STUDENT_LIST}${page}`;
        if(page_flag?.length){
            url=url+`&page_flag=${page_flag}`;
        }
        if (searchQuery?.length) {
            url = url + `&search=${searchQuery}`
        }
        url = url + `&limit=${limit}`
        fetcherGet(url)
            .then((response) => {
                const allStudentList = !isEmpty(response?.data) ? response?.data : {};
                dispatch(setStudentList(allStudentList));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getStudentProfileInfo(studentId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.GET_STUDENT_PROFILE_INFO}`;
        if (studentId) {
           url = url + `?user_id=${studentId}`
        }
        fetcherGet(url)
            .then((response) => {
                const stuentInfo = !isEmpty(response?.data) ? response?.data : {};
                dispatch(setStudentProfileIfo(stuentInfo));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getMaterial(studentId, page=1, limit=10) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.GET_MENTOR_MATERIAL}`;
        if (studentId) {
           url = url + `?student_id=${studentId}`
        }
        url = url + `&page=${page}&limit=${limit}`;
        fetcherGet(url)
            .then((response) => {
                const data = !isEmpty(response?.data) ? response?.data : {};
                dispatch(setMaterialData(data));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function updateFlag(flagId, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherDelete(APIS?.REMOVE_FLAG + flagId)
            .then(() => {
                callBack()
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getStudentListForMentor(page = 1, searchQuery, limit=10 ) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.GET_STUDENT_LIST_FOR_MENTOR}${page}`;
        if (searchQuery?.length) {
            url = url + `&search=${searchQuery}`
        }
        if(limit > 0){
            url = url + `&limit=${limit}`
        }
        if(limit < 0){
            url=url+`&page_flag=view_all`;
        }
        fetcherGet(url)
            .then((response) => {
                const allStudentList = !isEmpty(response?.data) ? response?.data : {};
                dispatch(setStudentList(allStudentList));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getMentorListForAdmin(page = 1, searchQuery, limit=10, page_flag) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.GET_MENTOR_LIST_ADMIN}${page}`;
        if(page_flag?.length){
            url=url+`&page_flag=${page_flag}`;
        }
        if (searchQuery?.length) {
            url = url + `&search=${searchQuery}`
        }
        url = url + `&limit=${limit}`
        fetcherGet(url)
            .then((response) => {
                const allMentorList = !isEmpty(response?.data) ? response?.data : {};
                dispatch(setAdminMentorList(allMentorList));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function checkSurveyStatus() {
    return (dispatch) => {
        // dispatch(setLoader(true));
        fetcherGet(APIS.CHECK_SURVEY)
            .then((res) => {
                if (res?.data?.is_survey_completed) {
                    dispatch(setSurveyCompleted(true));
                } else {
                    dispatch(setSurveyCompleted(false));
                }
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
            });
    };
}

export function putSurvey() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.SET_SURVEY)
            .then(() => {
                dispatch(setSurveyCompleted(true));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
            });
    };
}

export function getSession(endPoint, redirects, plans) {
    return (dispatch) => {
        dispatch(setLoader(true));
        const URL = endPoint + redirects + plans;
        fetcherGet(URL)
            .then((res) => {
                if (meetingPlans.PLANS_LOOK_UP === plans) {
                    dispatch(setPlansLookUp(res?.data));
                } else if (meetingPlans.MEETING_PLANS === plans) {
                    dispatch(setMeetingPlans(res?.data));
                } else {
                    dispatch(setEssayPlans(res?.data));
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getCombinedPlan(flag = false) {
    return (dispatch) => {
        dispatch(setLoader(true));
        const URL = APIS.GET_PLANS + flag;
        fetcherGet(URL)
            .then((res) => {
                const data = res?.data?.result?.sort((a, b) => parseInt(a.title) - parseInt(b.title)) || [];
                // const data = res?.data?.result;
                if (SpecificPlan.is_meeting === flag) {
                    dispatch(setMeetingPlans(data));
                } else if(SpecificPlan.is_document === flag) {
                    dispatch(setEssayPlans(data));
                } else {
                    dispatch(setCombinedPlans(data));
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

// To get single session id for multi select
export function getUniqueSessionId(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.GET_SESSION_ID, payload)
            .then((res) => {
                if (callBack && typeof callBack === 'function') {
                    callBack(res?.data?.sessionId);
                }
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getUserSubscription(studentId) {
    let url = `${APIS.GET_USER_SUBSCRIPTION}`;
    if (studentId) {
       url = url + `?user_id=${studentId}`
    }
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(url)
            .then((res) => {
                dispatch(setUserSubcription(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getUserCredit(studentId) {
    
    let url = `${APIS.USER_GET_CREDIT}`;
    if (studentId) {
       url = url + `?user_id=${studentId}`
    }
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(url)
            .then((res) => {
                dispatch(setUserCredit(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}
    export const putTranscriptFile = async (file, studentId) => {
        try {
          const formData = new FormData();
          formData.append('file', file);
          let url;
          if(!isEmpty(studentId)){
            url = `${ APIS.TRANSCRIPT_FILE}?user_id=${studentId}`
          } else {
            url = APIS.TRANSCRIPT_FILE;
          }
          const response = await axios.put(url, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${getAccessToken()}`
            }
          });
          return response;
        } catch (error) {
          return error;
        }
      };

export function updatePlan(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.UPDATE_PLAN, payload)
            .then((res) => {
                dispatch(getUserSubscription());
                if (callBack && typeof callBack === 'function') {
                    callBack(res?.data);
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

// new downgrade
export function downgradeToFreeSubscription(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.DOWNGRADE_TO_FREE_SUBSCRIPTION, payload)
            .then((res) => {
                if (callBack && typeof callBack === 'function') {
                    callBack(res?.data?.sessionId);
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getAllGrade(page = 1){
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS?.GET_ALL_GRADES}${page}`)
            .then((response) => {
                const grade = !isEmpty(response?.data) ? response?.data : {}
                dispatch(setAllGrade(grade));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export const postStudentCsvFile = async (data, userType, callback) => {
    let url;
    if(userType === role.student){
        url = APIS.UPLOAD_STUDENT_CSV;
    }else if(userType === role.mentor){
        url = APIS.UPLOAD_MENTOR_CSV;
    }else if(userType === role.admin){
        url = APIS.UPLOAD_ADMINISTRATOR_CSV
    }
    try {
      const formData = new FormData();
      formData.append('file', data?.file);
      if(userType === role.student) {
        formData.append('document_credits_for_student', data?.document_credits_for_student);
        formData.append('meeting_credits_for_student', data?.meeting_credits_for_student);
      }
      if(userType !== role.mentor) {
      formData.append('district_id', data?.district_id);
      formData.append('total_meetings_credits',data?.total_meetings_credits);
      formData.append('total_documents_credits',data?.total_documents_credits);
      }
      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${getAccessToken()}`
        }
      });
      return response;
    } catch (error) {
        if (callback && typeof callback === 'function') {
          callback(error?.response?.data?.data?.message);
        }
    }
  };
  export const getNotificationCount = () => {
    return (dispatch) => {
        fetcherGet(`${APIS?.NOTIFICATION_COUNT}`).then((response)=> {
           dispatch(setNotificationCount(response?.data));
           dispatch(setLoader(false));
        }).catch((error)=>{
          console.error(error)
          dispatch(setLoader(false));
        })
    }
  } 
  export const getNotifications = (page=1, limit=50) => {
    return (dispatch) => {
        // dispatch(setLoader(true));
        fetcherGet(`${APIS?.GET_NOTIFICATION}?page=${page}&limit=${limit}`)
            .then((response) => {
                const student = !isEmpty(response?.data) ? response?.data : {}
                dispatch(setNotifications(student));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
  }
  export const readNotifications = () => {
    return (dispatch) => {
        // dispatch(setLoader(true));
        fetcherPut(APIS?.READ_NOTIFICATION)
            .then((response) => {
                console.error(response)
                dispatch(getNotificationCount());
                dispatch(setLoader(false));
            })
            .catch((error) => {
                console.error(error)
                dispatch(setLoader(false));
            });
    };
  }

export function mentorRequestAction(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.MENTOR_REQUEST_ACTION, payload)
            .then(() => {
                dispatch(setLoader(false));
                if (callBack && typeof callBack === 'function') {
                    callBack(true);
                }
            })
            .catch(() => {
                dispatch(setLoader(false));
                if (callBack && typeof callBack === 'function') {
                    callBack(false);
                }
            });
    };
}

export const {
    setUserInfo,
    setLoggedInUserId,
    setStudentQuestions,
    setSavedAnswers,
    setSchoolList,
    setSurveyCompleted,
    setLanguage,
    setPrefarances,
    setFormErrorsBasicInfo,
    setFormErrorsAcademicBackground,
    setPrefarancesSaved,
    setSkipPrefarancesPage,
    setPlansLookUp,
    setMeetingPlans,
    setEssayPlans,
    setCombinedPlans,
    setUserSubcription,
    setUserCredit,
    setHighSchoolList,
    setAllGrade,
    setStudentList,
    setAdminMentorList,
    setFlagDetails,
    setStudentProfileIfo,
    setMaterialData,
    setSelectedStudent,
    setNotifications,
    setNotificationCount
} = userSlice.actions;

export default userSlice.reducer;
